{
  "fr": {
    "todo": {
      "actions": {
        "add": "Ajouter Tâche",
        "cancel": "Annuler",
        "delete_todo": "Supprimer tâche",
        "edit": "Modifier Tâche",
        "save": "Enregistrer"
      },
      "attributes": {
        "active": "Active",
        "assignee": "Responsable",
        "completed": "Terminé",
        "description": "Description",
        "due_date": "Échéance",
        "title": "Titre"
      },
      "labels": {
        "active": "active",
        "allDone": "Toutes les tâches sont terminées!",
        "allTodos": "Toutes les Tâches",
        "completed": "terminée",
        "filterTodos": "Filtrer les tâches",
        "filters": "Filtres",
        "myTodos": "Mes Tâches",
        "myTodosCount": "Mes tâches ({count})",
        "noActiveTodos": "Pas de tâches actives",
        "noActiveTodosDashboard": "Félicitations, vous n'avez pas de tâches actives!",
        "noCompletedYet": "Pas encore de tâches terminées.",
        "noTodosCustomer": "Génial! Vous n'avez aucune tâche ouverte.",
        "selectAProjectFirst": "Sélectionnez d'abord un projet",
        "showLess": "Montrer moins",
        "showOthers": "Montre plus | Montrer plus ({count})"
      },
      "toasts": {
        "create": "Tâche créée",
        "delete": "Tâche supprimée",
        "update": "Tâche mise à jour"
      },
      "validation": {
        "needtitle": "Le titre est requis"
      }
    }
  }
}
